import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { getPublicSiteSettings } from '../../api/publicPages';
import { getCombinedFontFamily } from '../../utils/fontStacks';
import { widgetLauncherVisualFromData, type WidgetLauncherVisual } from './widgetLauncherVisual';

export async function loadWidgetLauncherVisual(workspaceId: string): Promise<WidgetLauncherVisual> {
  const [site, widgetSnap] = await Promise.all([
    getPublicSiteSettings(workspaceId),
    getDoc(doc(db, `publicPages/${workspaceId}/settings`, 'widget')),
  ]);
  const fontFamily = getCombinedFontFamily(
    site?.textFontEn ?? site?.textFont ?? 'default',
    site?.textFontJp ?? site?.textFont ?? 'default',
  );
  const widget = widgetSnap.exists() ? (widgetSnap.data() as Record<string, unknown>) : null;
  const visual = widgetLauncherVisualFromData(widget, fontFamily);
  const button = (widget?.button ?? {}) as Record<string, unknown>;
  const hasButtonColor = typeof button.backgroundColor === 'string' && button.backgroundColor.length > 0;
  if (!hasButtonColor && site?.mainColor && /^#[0-9a-fA-F]{6}$/.test(site.mainColor)) {
    visual.backgroundColor = site.mainColor;
  }
  return visual;
}
